// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.13463"][{"5448":0}[chunkId]] || "1.13465") + "/" + chunkId + ".js";
};